// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7940) return "static/chunks/7940-3cbfff759432be8f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3124":"7964e2e380c9110f","9256":"dd63b10ae613cc73"}[chunkId] + ".js";
};